<template>
  <CustomTable ref="table" :elements=elements :data="data" :loadData="loadData">
    <template v-slot:header-options>
      <button @click="$refs.addUserModal.openModal()" class="button-icon"><span class="fas fa-user-plus"></span></button>
    </template>
    <template v-slot:table>
      <thead>
        <tr>
          <custom-header field="name">Identité</custom-header>
          <custom-header field="email" class="hide-for-mobile">Email</custom-header>
          <custom-header field="role">Rôle</custom-header>
          <custom-header field="groupName" class="hide-for-mobile">Groupe</custom-header>
          <custom-header field="isVerify" class="hide-for-mobile">Validité</custom-header>
          <custom-header field="state">Etat</custom-header>
          <custom-header field="createdAt" class="hide-for-mobile">Date de création</custom-header>
          <custom-header field="actions">Actions</custom-header>
        </tr>
      </thead>
      <tbody v-if="data && data.length > 0">
      <tr v-for="(user, index) in $refs.table.$refs.searchArray.simpleFilter(data)" :key="index">
          <custom-body field="name" class="truncate-cell" :title="user.name">{{ user.name }}</custom-body>
          <custom-body field="email" class="hide-for-mobile truncate-cell" :title="user.email">{{ user.email }}</custom-body>
          <custom-body field="role">{{ getLabelOfUserRole(user.role) }}</custom-body>
          <custom-body field="groupName" class="hide-for-mobile truncate-cell" :title="getLabelOfGroupName(user.groupName)">{{getLabelOfGroupName(user.groupName)}}</custom-body>
          <custom-body field="isVerify" class="hide-for-mobile">{{ user.isVerify ? "Oui" : "Non" }}</custom-body>
          <custom-body field="state">{{ getLabelOfActivationStatus(user.state) }}</custom-body>
          <custom-body field="createdAt" class="hide-for-mobile">{{ (new Date(user.createdAt)).toLocaleDateString("en-GB", formattedDateTime) }}</custom-body>
          <custom-body field="actions" style="min-width: 25px">
            <button v-if="canManageUser(user)" class="button-icon-custom" title="Modifier" @click="$refs.editUserModal.openModal(user)">
              <span class="fas fa-user-gear"></span>
              <!--<span class="fas fa-triangle-exclamation"></span>-->
            </button>
            <button v-if="canManageUser(user)" class="button-icon-custom" title="Bannir" @click="$refs.banUserModal.openModal(user)">
              <span class="fas fa-user-large-slash"></span>
            </button>
          </custom-body>
        </tr>
      </tbody>
      <tbody v-else><tr class="empty-row"><td colspan="8">Aucun utilisateur enregistré</td></tr></tbody>
    </template>
  </CustomTable>
  <EditUserModal ref="editUserModal" :callback=loadData />
  <BanUserModal ref="banUserModal" :callback=loadData />
  <AddUserModal ref="addUserModal" :callback=loadData />
</template>

<script>
    import { library } from '@fortawesome/fontawesome-svg-core';
    import EditUserModal from "@/components/modals/EditUserModal.vue";
    import BanUserModal from "@/components/modals/BanUserModal.vue";
    import AddUserModal from "@/components/modals/AddUserModal.vue";
    import {UserController} from "@/controllers/user/UserController";
    import { faMoneyBillTransfer, faList, faChevronLeft, faTriangleExclamation,
      faChevronRight, faUserLock, faUserCheck, faUserGear, faUserLargeSlash, faUserPlus } from "@fortawesome/free-solid-svg-icons";
    import CustomTable from "@/components/CustomTable.vue";
    import {RightService} from "@/services/RightService";
    import CustomHeader from "@/components/tables/CustomHeader.vue";
    import CustomBody from "@/components/tables/CustomBody.vue";
    import {formattedDateTime} from "@/utils";
    import {ACTIVATION_STATUS_ENUM} from "@/models/activationStatusEnum";
    library.add(faChevronLeft, faChevronRight, faMoneyBillTransfer, faList, faUserLock,
        faUserCheck, faUserGear, faTriangleExclamation, faUserLargeSlash, faUserPlus);

    export default {
        name: 'UserTable',
      computed: {
        formattedDateTime() {
          return formattedDateTime
        }
      },
        components: {
          CustomBody,
          CustomHeader,
          CustomTable,
          AddUserModal,
          BanUserModal,
          EditUserModal,
        },
        data: function () {
          return {
            data: [],
            elements: [
              {label: "Identité", value: "name", type: "text"},
              {label: "Email", value: "email", type: "text"},
              {label: "Groupe", value: "groupName", type: "text"},
              {label: "Etat", value: "state", type: "select", values: ACTIVATION_STATUS_ENUM},
              {label: "Date de création", value: "createdAt", type: "date"},
              {label: "Actions", value: undefined, type: undefined},
            ],
          }
        },
      mounted() {
        this.$refs.table.$refs.searchArray.initWithURLParams();
        this.loadData();
      },
      methods: {
        getLabelOfUserRole(role) {
          if (role === "ADMIN") {
            return "Administrateur"
          } else if (role === "CLASSIC") {
            return "Normal"
          } else if (role === "MODERATOR") {
            return "Modérateur"
          } else if (role === "NONE") {
            return "Pas de rôle"
          } else {
            return "Inconnu"}
          },
          getLabelOfGroupName(name){
            if(name === "super_admin"){ return "Super Administrateurs" }
            else if(name === "newer"){ return "Nouveaux" }
            else if(name === "unknown"){ return "Inconnus" }
            else{ return name}
          },
          getLabelOfActivationStatus(activationStatus){
            if(activationStatus === "ACTIVATED"){ return "Activé" }
            else if(activationStatus === "DEACTIVATED") { return "Désactivé" }
          },
          async loadData() {
            this.$refs.table?.startLoading();
            const resp = await UserController.getAll(this.$refs.table.buildURLParams())
            this.data = !resp.errors ? resp : [];
            this.$refs.table?.stopLoading();
          },
          canManageUser(user){
            return RightService.canManageUser(user);
          }
        }
    }
</script>

<style lang="stylus" scoped>
  @require '~/src/common/style/common.styl';

  // Texte trop long : tronqué par « … » (l'infobulle donne le texte entier) au lieu de déborder sur la colonne voisine
  .truncate-cell
    overflow hidden
    text-overflow ellipsis
    white-space nowrap

  .fa-triangle-exclamation
    position absolute
    height 14px !important
    margin-left -19px
    margin-top -2px
    color #de8900

  .button-icon
    margin-right 10px
</style>
